import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React__default from 'react';
import 'prop-types';
import { u as useUtils } from './dimensions-bd426990.js';
import 'clsx';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@material-ui/core/Grid';
import '@material-ui/core/Typography';
import '@material-ui/core/IconButton';
import '@material-ui/core/Toolbar';
import { createSvgIcon } from '@material-ui/core/utils';
import { T as TimePickerToolbar } from './ClockView-03c73477.js';
import './ArrowSwitcher-b0a281b3.js';
import '@material-ui/core/styles';
import '@babel/runtime/helpers/esm/typeof';
import './utils-66277a98.js';
import './Calendar-afaf51ae.js';
import { m as makePickerWithStateAndWrapper, R as ResponsiveWrapper, D as DesktopWrapper, M as MobileWrapper, S as StaticWrapper, t as timePickerDefaultProps } from './Wrapper-4adf0bef.js';
import '@material-ui/core/useMediaQuery';
import '@material-ui/core/Button';
import '@material-ui/core/DialogActions';
import '@material-ui/core/DialogContent';
import '@material-ui/core/Dialog';
import '@material-ui/core/TextField';
import { p as pick12hOr24hFormat } from './Picker-2bbc7ba8.js';
import './WrapperVariantContext-747fba40.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@material-ui/core/InputAdornment';
import 'rifm';
import '@material-ui/core/Popover';
import '@material-ui/core/Grow';
import '@material-ui/core/Paper';
import '@material-ui/core/Modal/TrapFocus';
import '@material-ui/core/Popper';
import './useKeyDown-e9a6112c.js';
import './usePickerState-71de5ec1.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/inherits';
import './Clock-9baa7a72.js';
import '@material-ui/core/ButtonBase';
import '@material-ui/core/CircularProgress';
import 'react-transition-group';
import './Day.js';
import '@material-ui/core/Fade';

var ClockIcon = createSvgIcon(React__default.createElement(React__default.Fragment, null, React__default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), React__default.createElement("path", {
  d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
})), 'ClockIcon');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function getTextFieldAriaText(value, utils) {
  return value && utils.isValid(utils.date(value)) ? "Choose time, selected time is ".concat(utils.format(utils.date(value), 'fullTime')) : 'Choose time';
}

function useDefaultProps(_ref) {
  var ampm = _ref.ampm,
      mask = _ref.mask,
      inputFormat = _ref.inputFormat,
      _ref$openTo = _ref.openTo,
      openTo = _ref$openTo === void 0 ? 'hours' : _ref$openTo,
      _ref$views = _ref.views,
      views = _ref$views === void 0 ? ['hours', 'minutes'] : _ref$views;
  var utils = useUtils();
  var willUseAmPm = ampm !== null && ampm !== void 0 ? ampm : utils.is12HourCycleInCurrentLocale();
  return _objectSpread({}, timePickerDefaultProps, {
    views: views,
    openTo: openTo,
    ampm: willUseAmPm,
    acceptRegex: willUseAmPm ? /[\dapAP]/gi : /\d/gi,
    mask: mask || willUseAmPm ? '__:__ _M' : '__:__',
    getOpenDialogAriaText: getTextFieldAriaText,
    keyboardIcon: React__default.createElement(ClockIcon, null),
    inputFormat: pick12hOr24hFormat(inputFormat, ampm, {
      localized: utils.formats.fullTime,
      '12h': utils.formats.fullTime12h,
      '24h': utils.formats.fullTime24h
    })
  });
}

var TimePicker = makePickerWithStateAndWrapper(ResponsiveWrapper, {
  useDefaultProps: useDefaultProps,
  DefaultToolbarComponent: TimePickerToolbar
});
var DesktopTimePicker = makePickerWithStateAndWrapper(DesktopWrapper, {
  useDefaultProps: useDefaultProps,
  DefaultToolbarComponent: TimePickerToolbar
});
var MobileTimePicker = makePickerWithStateAndWrapper(MobileWrapper, {
  useDefaultProps: useDefaultProps,
  DefaultToolbarComponent: TimePickerToolbar
});
var StaticTimePicker = makePickerWithStateAndWrapper(StaticWrapper, {
  useDefaultProps: useDefaultProps,
  DefaultToolbarComponent: TimePickerToolbar
});

export { DesktopTimePicker, MobileTimePicker, StaticTimePicker, TimePicker, getTextFieldAriaText };
//# sourceMappingURL=TimePicker.js.map
